module.exports = __webpack_public_path__ + "static/media/ETHUSDT.3759bbe0.png";